/**
 * Enumeration containing all the rights used on the front end with their description.
 * User rights depend on the project.
 */
export enum BydUserRightsEnum {
  // DEFAULT MODULE
  /**
   * The default right that all users should have.
   */
  DEFAULT = 501,
  // RIGHTS MODULE
  /**
   * Can edit rights.
   */
  RIGHTS_EDIT = 706,
  // FORMS MODULE
  /**
   * Can edit forms.
   */
  FORMS_EDIT = 704,
  /**
   * Can edit forms.
   */
  FORMS_DELETE = 1264,
  /**
   * Has access to forms.
   */
  FORMS_ACCESS = 807,
  // GED MODULE
  /**
   * Has access to the GED.
   */
  GED_ACCESS = 1309,
  /**
   * Has access to the nuxeo GED from MyAdminSite.
   */
  GED_ADMIN_ACCESS = 1300,
  // LINEAR MODULE
  /**
   * Can edit linear data (works, lanes).
   */
  LINEAR_EDIT = 1296,
  /**
   * Has access to the synoptics (linear).
   */
  SYNOPTICS_ACCESS = 1297,
  // PINS MODULE
  /**
   * Has access to pins.
   */
  PINS_ACCESS = 455,
  /**
   * Can edit pins.
   */
  PINS_EDIT = 702,
  /**
   * Locks all edition on a pin if it has the status DONE.
   */
  PIN_LOCK_DONE = 1049,
  /**
   * Can edit a pin's due date
   */
  PIN_DUEDATE_EDIT = 1179,
  /**
   * Can edit rights and role
   */
  SETUP_ROLE = 1310,
  /**
   * Can open configuration observation
   */
  SETUP_RESERVE = 702,
  /**
   * Can configure Plans
   */
  SETUP_PLAN = 1311,
  /**
   * Critical in place of stars for items
   */
  PINS_CRITICAL = 1143,
  /**
   * Can access 3D maps
   */
  ACCESS_3D = 1110,
  /**
   * Can change the pin's emitter
   */
  CHANGE_EMITTER = 458,
}
